const tr = {
  // Common
  "common.save": "Kaydet",
  "common.cancel": "İptal",
  "common.delete": "Sil",
  "common.edit": "Düzenle",
  "common.create": "Oluştur",
  "common.search": "Ara",
  "common.filter": "Filtre",
  "common.reset": "Sıfırla",
  "common.close": "Kapat",
  "common.confirm": "Onayla",
  "common.yes": "Evet",
  "common.no": "Hayır",
  "common.loading": "Yükleniyor...",
  "common.saved": "Kaydedildi!",
  "common.error": "Hata",
  "common.success": "Başarılı",
  "common.preview": "Önizleme",
  "common.actions": "İşlemler",
  "common.status": "Durum",
  "common.active": "Aktif",
  "common.inactive": "Pasif",
  "common.all": "Tümü",
  "common.none": "Yok",
  "common.total": "Toplam",
  "common.back": "Geri",
  "common.next": "İleri",
  "common.refresh": "Yenile",
  "common.add": "Ekle",
  "common.remove": "Kaldır",
  "common.upload": "Yükle",
  "common.download": "İndir",
  "common.copy": "Kopyala",
  "common.publish": "Yayınla",
  "common.archive": "Arşivle",
  "common.draft": "Taslak",
  "common.name": "Ad",
  "common.description": "Açıklama",
  "common.date": "Tarih",
  "common.views": "Görüntüleme",
  "common.author": "Yazar",
  "common.category": "Kategori",
  "common.image": "Görsel",
  "common.title": "Başlık",
  "common.slug": "Slug",
  "common.email": "E-posta",
  "common.password": "Şifre",
  "common.role": "Rol",
  "common.website": "Web Sitesi",
  "common.mockData": "Demo Verisi",
  "common.liveData": "Canlı Veri",
  "common.demoMode": "Demo Modu",
  "common.noResults": "Sonuç bulunamadı.",
  "common.irreversible": "Bu işlem geri alınamaz.",

  // Navigation
  "nav.dashboard": "Gösterge Paneli",
  "nav.content": "İçerik",
  "nav.articles": "Makaleler",
  "nav.categories": "Kategoriler",
  "nav.authors": "Yazarlar",
  "nav.media": "Medya Kütüphanesi",
  "nav.website": "Web Sitesi",
  "nav.ads": "Reklamlar",
  "nav.homepage": "Ana Sayfa",
  "nav.breaking": "Son Dakika",
  "nav.seo": "SEO",
  "nav.newsletter": "Bülten",
  "nav.pages": "Sayfalar",
  "nav.system": "Sistem",
  "nav.settings": "Ayarlar",
  "nav.users": "Kullanıcılar & Roller",
  "nav.analytics": "Analitik",
  "nav.brand": "Marka",
  "nav.closeMenu": "Menüyü kapat",
  "nav.openMenu": "Menüyü aç",
  "nav.adminPanel": "Yönetim Paneli",
  "nav.viewWebsite": "Web Sitesi",
  "nav.loggedInAs": "Giriş yapıldı",
  "nav.logout": "Çıkış Yap",

  // Login
  "login.title": "Yönetici Girişi",
  "login.subtitle": "Web sitesini yönetmek için giriş yapın.",
  "login.email": "E-posta",
  "login.password": "Şifre",
  "login.submit": "Giriş Yap",
  "login.submitting": "Giriş yapılıyor...",
  "login.demoAccounts": "Demo hesapları:",
  "login.error.invalid": "Geçersiz e-posta veya şifre. Lütfen bilgilerinizi kontrol edin.",
  "login.error.unauthorized": "Hesabınızın yönetici yetkisi yok. Lütfen yönetici ile iletişime geçin.",
  "login.error.noProfile": "Hesabınız bulundu ancak henüz bir profil oluşturulmamış. Profil otomatik oluşturuldu. Rol ataması için yönetici ile iletişime geçin.",
  "login.error.supabase": "Veritabanı bağlantı hatası",
  "login.error.unknown": "Bilinmeyen bir hata oluştu. Lütfen tekrar deneyin.",
  "login.helpText": "Supabase e-posta ve şifrenizle giriş yapın. Hesabınızın \"profiles\" tablosunda \"admin\" veya \"super_admin\" rolüne sahip olması gerekir.",
  "login.forgotPassword": "Şifremi unuttum?",

  // Forgot password
  "forgotPassword.title": "Şifre Sıfırlama",
  "forgotPassword.subtitle": "E-posta adresinizi girin. Size şifre sıfırlama bağlantısı göndereceğiz.",
  "forgotPassword.email": "E-posta Adresi",
  "forgotPassword.submit": "Bağlantı Gönder",
  "forgotPassword.submitting": "Gönderiliyor...",
  "forgotPassword.backToLogin": "Girişe Dön",
  "forgotPassword.success.title": "E-posta Gönderildi!",
  "forgotPassword.success.message": "Bu e-posta ile bir hesap varsa, kısa süre içinde şifre sıfırlama bağlantısı alacaksınız. Spam klasörünüzü de kontrol edin.",
  "forgotPassword.error.generic": "E-posta gönderilirken hata oluştu. Lütfen tekrar deneyin.",

  // Reset password
  "resetPassword.title": "Yeni Şifre Belirle",
  "resetPassword.subtitle": "Yeni şifrenizi girin.",
  "resetPassword.newPassword": "Yeni Şifre",
  "resetPassword.confirmPassword": "Şifreyi Onayla",
  "resetPassword.submit": "Şifreyi Kaydet",
  "resetPassword.submitting": "Kaydediliyor...",
  "resetPassword.success.title": "Şifre Değiştirildi!",
  "resetPassword.success.message": "Şifreniz başarıyla değiştirildi. Giriş sayfasına yönlendiriliyorsunuz.",
  "resetPassword.error.mismatch": "Şifreler eşleşmiyor.",
  "resetPassword.error.tooShort": "Şifre en az 8 karakter olmalıdır.",
  "resetPassword.error.generic": "Şifre değiştirilirken hata oluştu. Lütfen tekrar deneyin.",
  "resetPassword.error.invalidLink": "Bu bağlantı geçersiz veya süresi dolmuş. Lütfen yeni bir bağlantı isteyin.",

  // Dashboard
  "dashboard.title": "Gösterge Paneli",
  "dashboard.overview": "Genel Bakış",
  "dashboard.quickActions": "Hızlı İşlemler",
  "dashboard.mostRead": "En Çok Okunanlar",
  "dashboard.latestArticles": "Son Makaleler",
  "dashboard.allArticles": "Tüm makaleleri göster",
  "dashboard.adSenseReady": "AdSense Hazır",
  "dashboard.breaking": "Son Dakika",
  "dashboard.stats.articles": "Makaleler",
  "dashboard.stats.published": "yayınlandı",
  "dashboard.stats.drafts": "Taslaklar",
  "dashboard.stats.scheduled": "planlandı",
  "dashboard.stats.categories": "Kategoriler",
  "dashboard.stats.authors": "Yazarlar",
  "dashboard.stats.columnists": "Köşe Yazarları",
  "dashboard.stats.views": "Görüntüleme",
  "dashboard.stats.ads": "Reklamlar",
  "dashboard.stats.slots": "Slot",
  "dashboard.stats.newsletter": "Bülten",
  "dashboard.stats.subscribers": "Abone",
  "dashboard.stats.regular": "Düzenli",
  "dashboard.quickAction.newArticle": "Yeni Makale",
  "dashboard.quickAction.breaking": "Son Dakika",
  "dashboard.quickAction.media": "Görseller",
  "dashboard.quickAction.seo": "SEO",
  "dashboard.quickAction.newsletter": "Bülten",
  "dashboard.quickAction.analytics": "Analitik",
  "dashboard.article.views": "Görüntüleme",
  "dashboard.article.edit": "Düzenle",

  // Articles
  "articles.title": "Makaleler",
  "articles.total": "makale toplam",
  "articles.new": "Yeni Makale",
  "articles.search": "Makale ara...",
  "articles.allCategories": "Tüm Kategoriler",
  "articles.allStatus": "Tüm Durumlar",
  "articles.allAuthors": "Tüm Yazarlar",
  "articles.selected": "seçildi",
  "articles.bulkPublish": "Yayınla",
  "articles.bulkArchive": "Arşivle",
  "articles.bulkDelete": "Sil",
  "articles.deleteTitle": "Makale silinsin mi?",
  "articles.deleteConfirm": "Bu işlem geri alınamaz. Makale kalıcı olarak kaldırılacak.",
  "articles.deleted": "Makale silindi.",
  "articles.deleteError": "Silme sırasında hata oluştu.",
  "articles.published": "Makale yayınlandı.",
  "articles.publishError": "Yayınlama sırasında hata oluştu.",
  "articles.archived": "Makale arşivlendi.",
  "articles.archiveError": "Arşivleme sırasında hata oluştu.",
  "articles.status.draft": "Taslak",
  "articles.status.pending_review": "İnceleme",
  "articles.status.published": "Yayınlandı",
  "articles.status.scheduled": "Planlandı",
  "articles.status.archived": "Arşivlendi",
  "articles.col.article": "Makale",
  "articles.col.category": "Kategori",
  "articles.col.author": "Yazar",
  "articles.col.status": "Durum",
  "articles.col.date": "Tarih",
  "articles.col.views": "Görüntüleme",
  "articles.col.flags": "Bayraklar",
  "articles.col.actions": "İşlemler",
  "articles.noFound": "Makale bulunamadı.",
  "articles.loading": "Makaleler yükleniyor...",

  // Categories
  "categories.title": "Kategoriler",
  "categories.total": "kategori toplam",
  "categories.new": "Yeni Kategori",
  "categories.search": "Kategori ara...",
  "categories.stats.total": "Toplam",
  "categories.stats.active": "Aktif",
  "categories.stats.inMenu": "Menüde",
  "categories.stats.homepage": "Ana Sayfa",
  "categories.createTitle": "Yeni Kategori Oluştur",
  "categories.editTitle": "düzenle",
  "categories.deleteTitle": "Kategori silinsin mi?",
  "categories.deleteConfirm": "Bu işlem geri alınamaz. Bu kategorideki tüm makalelerin yeniden atanması gerekecek.",
  "categories.tab.general": "Genel",
  "categories.tab.seo": "SEO",
  "categories.tab.display": "Görünüm",
  "categories.tab.subcategories": "Alt Kategoriler",
  "categories.col.order": "Sıra",
  "categories.col.category": "Kategori",
  "categories.col.slug": "Slug",
  "categories.col.subcategories": "Alt Kategoriler",
  "categories.col.articles": "Makaleler",
  "categories.col.menu": "Menü",
  "categories.col.homepage": "Ana Sayfa",
  "categories.col.status": "Durum",
  "categories.col.actions": "İşlemler",
  "categories.noFound": "Kategori bulunamadı.",

  // Categories form
  "categories.form.name": "Ad *",
  "categories.form.namePlaceholder": "Kategori adı",
  "categories.form.slug": "URL kısa adı *",
  "categories.form.slugPlaceholder": "kategori-url-adi",
  "categories.form.description": "Açıklama",
  "categories.form.descriptionPlaceholder": "Kategorinin kısa açıklaması...",
  "categories.form.descriptionCharCount": "karakter",
  "categories.form.imageUrl": "Kategori görseli (URL)",
  "categories.form.imageUrlPlaceholder": "https://...",
  "categories.form.imagePreview": "Önizleme",
  "categories.form.color": "Renk",
  "categories.form.activeToggle": "Kategori aktif",
  "categories.form.activeToggleDesc": "Kategori görünür ve erişilebilir",
  "categories.form.seoTitle": "SEO başlığı",
  "categories.form.seoTitlePlaceholder": "Bu kategori için SEO başlığı...",
  "categories.form.seoTitleCharCount": "karakter önerilir",
  "categories.form.seoDescription": "SEO açıklaması",
  "categories.form.seoDescriptionPlaceholder": "Arama motorları için meta açıklama...",
  "categories.form.seoDescriptionCharCount": "karakter önerilir",
  "categories.form.googlePreview": "Google önizlemesi",
  "categories.form.showInMenu": "Ana menüde göster",
  "categories.form.showInMenuDesc": "Kategori navigasyonda görünür",
  "categories.form.showOnHomepage": "Ana sayfada göster",
  "categories.form.showOnHomepageDesc": "Kategori bölümü ana sayfada görünür",
  "categories.form.menuOrder": "Menü sırası",
  "categories.form.homepageOrder": "Ana sayfa sırası",
  "categories.form.headerPreview": "Kategori başlığı önizlemesi",
  "categories.form.categoryNamePlaceholder": "Kategori adı",
  "categories.form.descriptionShortPlaceholder": "Açıklama...",
  "categories.form.noSubcategories": "Alt kategori yok",
  "categories.form.addSubcategory": "Yeni alt kategori ekle",
  "categories.form.subcategoryNamePlaceholder": "Alt kategori adı",
  "categories.form.subcategorySlugPlaceholder": "alt-kategori-url-adi",
  "categories.form.addSubcategoryButton": "Alt kategori ekle",

  // Users
  "users.title": "Kullanıcılar & Roller",
  "users.invite": "Davet Et",
  "users.search": "Kullanıcı ara...",
  "users.changeRole": "Rol Değiştir",
  "users.changeRoleTitle": "Rol Değiştir",
  "users.inviteTitle": "Kullanıcı Davet Et",
  "users.inviteName": "Ad",
  "users.inviteEmail": "E-posta",
  "users.inviteRole": "Rol",
  "users.inviteSubmit": "Davet Gönder",
  "users.roleChanged": "Rol güncellendi.",
  "users.roleError": "Rol güncellenirken hata oluştu.",
  "users.statusChanged": "Durum güncellendi.",
  "users.statusError": "Durum güncellenirken hata oluştu.",
  "users.inviteSent": "Davet gönderildi.",
  "users.inviteError": "Davet gönderilirken hata oluştu.",
  "users.col.user": "Kullanıcı",
  "users.col.role": "Rol",
  "users.col.status": "Durum",
  "users.col.lastLogin": "Son Giriş",
  "users.col.actions": "İşlemler",
  "users.noFound": "Kullanıcı bulunamadı.",
  "users.permissionsMatrix": "Yetki Matrisi",

  // Brand
  "brand.title": "Marka Ayarları",
  "brand.texts": "Metinler",
  "brand.logos": "Logolar",
  "brand.colors": "Renkler",
  "brand.preview": "Önizleme",
  "brand.siteName": "Site Adı",
  "brand.slogan": "Slogan",
  "brand.logoStandard": "Logo (Standart)",
  "brand.logoDark": "Logo (Koyu)",
  "brand.favicon": "Favicon",
  "brand.primaryColor": "Ana Renk (Metin, Başlık)",
  "brand.accentColor": "Vurgu Rengi (Logo, Bağlantılar, Butonlar)",
  "brand.saved": "Kaydedildi",
  "brand.reset": "Sıfırla",

  // Article Editor
  "articleForm.newArticle": "Yeni Makale",
  "articleForm.editArticle": "Makale Düzenle",
  "articleForm.duplicate": "Kopyala",
  "articleForm.preview": "Önizleme",
  "articleForm.delete": "Sil",
  "articleForm.cancel": "İptal",
  "articleForm.saveDraft": "Taslak Kaydet",
  "articleForm.publish": "Yayınla",
  "articleForm.saving": "Kaydediliyor...",
  "articleForm.publishing": "Yayınlanıyor...",
  "articleForm.saved": "Kaydedildi",
  "articleForm.saveError": "Kaydetme hatası:",
  "articleForm.tab.content": "İçerik",
  "articleForm.tab.media": "Medya",
  "articleForm.tab.settings": "Ayarlar",
  "articleForm.tab.seo": "SEO",
  "articleForm.tab.links": "Bağlantılar",
  "articleForm.title": "Başlık",
  "articleForm.titlePlaceholder": "Makale başlığını girin...",
  "articleForm.subtitle": "Alt başlık",
  "articleForm.subtitlePlaceholder": "Kısa alt başlık...",
  "articleForm.slug": "URL kısa adı",
  "articleForm.slugPlaceholder": "makale-url-adi",
  "articleForm.excerpt": "Kısa açıklama",
  "articleForm.excerptPlaceholder": "Kısa özet...",
  "articleForm.content": "İçerik",
  "articleForm.contentPlaceholder": "Makale içeriğini girin... HTML etiketleri desteklenir.",
  "articleForm.contentChars": "karakter | HTML desteklenir",
  "articleForm.featuredImage": "Öne çıkan görsel",
  "articleForm.gallery": "Görsel galerisi",
  "articleForm.addImage": "Görsel ekle",
  "articleForm.noGallery": "Galeride görsel yok",
  "articleForm.categoryAuthor": "Kategori & Yazar",
  "articleForm.category": "Kategori",
  "articleForm.selectCategory": "Kategori seçin",
  "articleForm.noCategories": "Henüz kategori yok. Önce kategori oluşturmalısınız.",
  "articleForm.createCategory": "Kategori oluştur",
  "articleForm.subcategory": "Alt kategori",
  "articleForm.author": "Yazar",
  "articleForm.selectAuthor": "Yazar seçin",
  "articleForm.noAuthors": "Henüz yazar yok. Önce yazar oluşturmalısınız.",
  "articleForm.createAuthor": "Yazar oluştur",
  "articleForm.tags": "Etiketler",
  "articleForm.tagsPlaceholder": "Etiket1, Etiket2, Etiket3",
  "articleForm.statusPublishing": "Durum & Yayın",
  "articleForm.status": "Durum",
  "articleForm.publishDate": "Yayın tarihi",
  "articleForm.status.draft": "Taslak",
  "articleForm.status.pending_review": "İnceleme bekliyor",
  "articleForm.status.published": "Yayında",
  "articleForm.status.scheduled": "Zamanlanmış",
  "articleForm.status.archived": "Arşivlendi",
  "articleForm.specialFlags": "Özel işaretler",
  "articleForm.flag.featured": "Öne çıkan makale",
  "articleForm.flag.breaking": "Son dakika haberi",
  "articleForm.flag.topNews": "Manşet haber",
  "articleForm.flag.homepageSlider": "Ana sayfa slayt",
  "articleForm.flag.topNewsColumn": "Manşet sütunu",
  "articleForm.flag.categoryFeatured": "Kategori öne çıkan",
  "articleForm.options": "Seçenekler",
  "articleForm.commentsEnabled": "Yorumları etkinleştir",
  "articleForm.commentsEnabledDesc": "Okuyucular yorum bırakabilir",
  "articleForm.adsEnabled": "Reklamları etkinleştir",
  "articleForm.adsEnabledDesc": "Makalede reklamlar gösterilir",
  "articleForm.seoTitle": "SEO başlığı",
  "articleForm.seoDescription": "SEO açıklaması",
  "articleForm.focusKeyword": "Odak anahtar kelime",
  "articleForm.canonicalUrl": "Kanonik URL",
  "articleForm.imageAlt": "Görsel alt metni",
  "articleForm.noIndex": "Sayfayı indeksleme (noindex)",
  "articleForm.noIndexDesc": "Arama motorlarının bu sayfayı indekslemesini engeller",
  "articleForm.articleInfo": "Makale bilgisi",
  "articleForm.readTime": "Okuma süresi:",
  "articleForm.wordCount": "Kelime sayısı:",
  "articleForm.estimatedReadTime": "Tahmini okuma süresi",
  "articleForm.statusSummary": "Durum özeti",
  "articleForm.deleteTitle": "Makale silinsin mi?",
  "articleForm.deleteConfirm": "Bu işlem geri alınamaz. Makale kalıcı olarak kaldırılacak.",
  "articleForm.previewTitle": "Makale Önizleme",
  "articleForm.breadcrumbArticles": "Makaleler",
  "articleForm.columnistNote": "Bu makale köşe yazısı olarak işaretlenecek",
  "articleForm.scheduledNote": "Bu makale planlanmış tarihte otomatik yayınlanacak.",
  "articleForm.sources": "Kaynaklar & Referanslar",
  "articleForm.addSource": "Kaynak ekle",
  "articleForm.noSources": "Kaynak eklenmedi",
  "articleForm.internalLinks": "İç bağlantılar",
  "articleForm.addInternalLink": "Bağlantı ekle",
  "articleForm.noInternalLinks": "İç bağlantı yok",
  "articleForm.externalLinks": "Dış bağlantılar",
  "articleForm.addExternalLink": "Bağlantı ekle",
  "articleForm.noExternalLinks": "Dış bağlantı yok",
  "articleForm.seoWarnings": "SEO uyarıları",
  "articleForm.suggestKeywords": "Öneriler",
  "articleForm.suggestedKeywords": "Önerilen Anahtar Kelimeler",
  "articleForm.suggestKeywordsHint": "Makale içeriğindeki kelime sıklığına ve önemine göre belirlenmiştir.",
  "articleForm.noKeywordSuggestions": "Anahtar kelime önerisi bulunamadı. Lütfen daha fazla içerik girin.",
  "articleForm.seoScoreTitle": "SEO Puanı",
  "articleForm.seoScoreDesc": "Makalenin SEO kalitesinin gerçek zamanlı değerlendirmesi.",
  "articleForm.seoScoreExcellent": "Mükemmel",
  "articleForm.seoScoreGood": "İyi",
  "articleForm.seoScoreFair": "Yeterli",
  "articleForm.seoScorePoor": "Geliştirilebilir",
  "articleForm.seoOk": "Tüm SEO alanları doğru doldurulmuş!",
  "articleForm.googlePreview": "Google arama sonucu önizleme",
  "articleForm.ogSection": "Open Graph (Facebook, LinkedIn)",
  "articleForm.twitterSection": "Twitter/X Kartı",
  "articleForm.seoGenerate": "SEO otomatik oluştur",
  "articleForm.seoGenerateDesc": "Boş SEO alanları makale içeriğinden oluşturulacak. Odak anahtar kelime önerileri metindeki sık geçen anlamlı kelimeleri analiz eder.",
  "articleForm.seoConfirmTitle": "SEO alanları oluştur",
  "articleForm.seoConfirmDesc": "Aşağıdaki alanlar boş ve doldurulacak:",
  "articleForm.seoSkippedDesc": "Aşağıdaki alanlar zaten değer içeriyor ve üzerine yazılmayacak:",
  "articleForm.seoOverwriteAll": "Mevcut alanları da üzerine yaz",
  "articleForm.seoField.title": "SEO başlığı",
  "articleForm.seoField.description": "Meta açıklaması",
  "articleForm.seoField.keyword": "Odak anahtar kelime",
  "articleForm.seoField.imageAlt": "Alt metni",
  "articleForm.seoField.slug": "Slug",
  "articleForm.seoGenerateBtn": "Oluştur",
  "articleForm.seoCancelBtn": "İptal",
  "articleForm.seoGenerated": "SEO alanları oluşturuldu!",
  "articleForm.seoPromptTitle": "SEO Alanları Boş",
  "articleForm.seoPromptDesc": "Bazı önemli SEO alanları henüz boş. Yayınlamadan önce otomatik olarak oluşturulmasını ister misiniz?",
  "articleForm.seoPromptGenerate": "Oluştur & Yayınla",
  "articleForm.seoPromptSkip": "Yine de yayınla",
  "articleForm.loadingCategories": "Kategoriler yükleniyor...",
  "articleForm.loadingAuthors": "Yazarlar yükleniyor...",
  "articleForm.categoriesError": "Kategoriler yüklenemedi",
  "articleForm.authorsError": "Yazarlar yüklenemedi",
  "articleForm.min": "dk.",
  "articleForm.active": "Aktif",
  "articleForm.inactive": "Pasif",

  // Dashboard extra
  "dashboard.stats.users": "Kullanıcılar",
  "dashboard.stats.registered": "kayıtlı",
  "dashboard.stats.media": "Medya",
  "dashboard.stats.files": "dosya",
  "dashboard.noArticles": "Henüz makale yok.",

  // Analytics
  "analytics.title": "Analitik",
  "analytics.header.subtitle": "Google Analytics 4 Entegrasyonu & Supabase Veritabanı Şeması",
  "analytics.tab.setup": "GA4 Kur",
  "analytics.tab.embed": "Embed Kodu",
  "analytics.tab.schema": "Veritabanı Şeması",
  "analytics.status.active": "Google Analytics 4 aktif",
  "analytics.status.trackingId": "İzleme ID",
  "analytics.status.hint": "Ziyaretçiler artık kaydediliyor.",
  "analytics.status.remove": "Kaldır",

  // Newsletter
  "newsletter.title": "Bülten",

  // Media
  "media.title": "Medya Kütüphanesi",

  // SEO
  "seo.title": "SEO",

  // Breaking
  "breaking.title": "Son Dakika",

  // Ads
  "ads.title": "Reklamlar",

  // Pages
  "pages.title": "Sayfalar",

  // Homepage
  "homepage.title": "Ana Sayfa",

  // Authors
  "authors.title": "Yazarlar",

  // Settings
  "settings.title": "Ayarlar",

  // Analytics
  "analytics.setup.title": "Adım Adım Kurulum",
  "analytics.step1.title": "Google Analytics Hesabı Oluşturun",
  "analytics.step1.desc": "analytics.google.com adresine gidin ve Google hesabınızla oturum açın. 'Hesap oluştur' düğmesine tıklayın ve talimatları izleyin.",
  "analytics.step1.link": "analytics.google.com'u aç",
  "analytics.step2.title": "GA4 Özelliği Kurun",
  "analytics.step2.desc": "Web siteniz için yeni bir özellik oluşturun. Özellik türü olarak 'Google Analytics 4' seçin. Web sitesi adınızı ve URL'nizi girin.",
  "analytics.step3.title": "Measurement ID Kopyalayın",
  "analytics.step3.desc": "Kurulumdan sonra Measurement ID'nizi şu adreste bulabilirsiniz: Yönetim → Özellik → Veri akışları → Akışınız → Measurement ID. Şöyle görünür: G-XXXXXXXXXX",
  "analytics.step4.title": "ID'yi Buraya Yapıştırın ve Kaydedin",
  "analytics.step4.desc": "Measurement ID'nizi aşağıdaki alana yapıştırın ve 'Kaydet' düğmesine tıklayın. İzleme hemen etkinleştirilecektir.",
  "analytics.input.title": "Measurement ID Girin",
  "analytics.input.subtitle": "GA4 Measurement ID'niz şöyle başlar",
  "analytics.input.placeholder": "G-XXXXXXXXXX",
  "analytics.input.error.empty": "Lütfen bir Measurement ID girin.",
  "analytics.input.error.invalid": "Geçersiz Measurement ID. Format: G-XXXXXXXXXX",
  "analytics.input.save": "Kaydet ve Etkinleştir",
  "analytics.input.saved": "Kaydedildi!",
  "analytics.input.help": "ID yerel olarak kaydedilir ve bir sonraki sayfa yüklemesinde otomatik olarak yüklenir.",
  "analytics.metric.users": "Ziyaretçiler (30 Gün)",
  "analytics.metric.pageviews": "Sayfa Görüntülemeleri (30 Gün)",
  "analytics.metric.sessions": "Oturumlar (30 Gün)",
  "analytics.metric.bounce": "Hemen Çıkma Oranı",
  "analytics.metric.empty": "—",
  "analytics.embed.title": "Otomatik Embed Kodu",
  "analytics.embed.active": "Aktif İzleme Kodu",
  "analytics.embed.inactive": "Önce 'GA4 Kurulum' sekmesinde bir Measurement ID kaydedin.",
  "analytics.embed.toSetup": "Kuruluma Git →",
  "analytics.howItWorks.title": "Nasıl Çalışır?",
  "analytics.howItWorks.step1": "Measurement ID localStorage'da kaydedilir.",
  "analytics.howItWorks.step2": "Uygulama başlangıcında App.tsx ID'yi okur ve GA4 script'ini dinamik olarak head'e enjekte eder.",
  "analytics.howItWorks.step3": "Her sayfa değişiminde (React Router) otomatik olarak page_view event'i GA4'e gönderilir.",
  "analytics.howItWorks.step4": "Admin sayfaları (/admin/*) izlemeden hariç tutulur.",
  "analytics.schema.title": "Supabase Veritabanı Şeması",
  "analytics.schema.subtitle": "Bu SQL'i Supabase SQL Editörünüzde çalıştırarak Helvetik Journal veritabanını kurun.",
  "analytics.schema.copy": "SQL Kopyala",
  "analytics.schema.copied": "Kopyalandı!",
  "analytics.schema.badges": ["articles Tablosu", "authors Tablosu", "Row Level Security", "RLS Politikaları"],
  "analytics.schema.step1": "Supabase Projesi Açın",
  "analytics.schema.step1.desc": "supabase.com adresine gidin ve projenizi açın.",
  "analytics.schema.step2": "SQL Editörünü Açın",
  "analytics.schema.step2.desc": "Sol menüden 'SQL Editor' ve ardından 'New query' seçeneğine tıklayın.",
  "analytics.schema.step3": "Şemayı Yapıştırın ve Çalıştırın",
  "analytics.schema.step3.desc": "Yukarıdaki SQL'i editöre yapıştırın ve 'Run' düğmesine tıklayın.",
  "analytics.schema.step4": "Ortam Değişkenlerini Ayarlayın",
  "analytics.schema.step4.desc": "VITE_SUPABASE_URL ve VITE_SUPABASE_ANON_KEY değerlerinin Readdy ayarlarınızda tanımlı olduğundan emin olun.",
  "analytics.remove.title": "GA4 İzlemeyi Kaldır?",
  "analytics.remove.description": "İzleme devre dışı bırakılacak. Ziyaretçiler artık kaydedilmeyecek. İstediğiniz zaman yeniden etkinleştirebilirsiniz.",
  "analytics.remove.cancel": "İptal",
  "analytics.remove.confirm": "Kaldır",

  // Users (additional)
  "users.header.subtitle": "kullanıcı public.profiles'tan",
  "users.refresh": "Yenile",
  "users.assignForm.title": "Rol Ata / Güncelle",
  "users.assignForm.subtitle": "Kullanıcı önce Supabase → Authentication → Users alanında oluşturulmalıdır. Bu form public.profiles tablosunda rolü ayarlar veya günceller.",
  "users.assignForm.email": "E-Posta",
  "users.assignForm.emailPlaceholder": "kullanici@helvetik.ch",
  "users.assignForm.name": "Görünen Ad (isteğe bağlı)",
  "users.assignForm.namePlaceholder": "Tam Ad",
  "users.assignForm.role": "Rol",
  "users.assignForm.submit": "Rolü Kaydet",
  "users.assignForm.saving": "Kaydediliyor...",
  "users.assignForm.success": "Rol başarıyla kaydedildi ve tablo güncellendi.",
  "users.howTo.title": "Kullanıcı Yönetimi Nasıl Çalışır?",
  "users.howTo.step1": "Kullanıcıyı Supabase → Authentication → Users → Add user alanında oluşturun.",
  "users.howTo.step2": "Yukarıya e-posta adresini girin, bir rol seçin ve 'Rolü Kaydet'e tıklayın.",
  "users.howTo.step3": "Kullanıcı hemen aşağıdaki tabloda görünecektir.",
  "users.howTo.note": "Admin Panel yeni Auth kullanıcıları oluşturamaz (Anon-Key güvenlik kısıtlaması). Yeni kullanıcılar her zaman önce Supabase Authentication'da oluşturulmalıdır.",
  "users.table.col.user": "Kullanıcı",
  "users.table.col.role": "Rol",
  "users.table.col.created": "Oluşturulma",
  "users.table.col.lastLogin": "Son Giriş",
  "users.table.col.status": "Durum",
  "users.table.col.actions": "İşlemler",
  "users.table.empty": "Kullanıcı bulunamadı.",
  "users.table.noProfiles": "public.profiles'ta kullanıcı bulunamadı",
  "users.table.noProfilesHint": "Kullanıcıyı Supabase → Authentication → Users alanında oluşturun, ardından yukarıdaki formu kullanarak rolü atayın.",
  "users.permissions.title": "Roller & İzinler Özeti",
  "users.permissions.permission": "İzin",
  "users.modal.editTitle": "Rolü Düzenle",
  "users.modal.newRole": "Yeni Rol",
  "users.modal.permissionsFor": "için izinler",
  "users.modal.cancel": "İptal",
  "users.modal.save": "Rolü Kaydet",
  "users.modal.saving": "Kaydediliyor...",
  "users.filter.allRoles": "Tüm Roller",
  "users.filter.allStatus": "Tüm Durumlar",
  "users.filter.active": "Aktif",
  "users.filter.inactive": "Pasif",
  "users.status.active": "Aktif",
  "users.status.inactive": "Pasif",
  "users.roleChanged": "Rol güncellendi.",
  "users.roleError": "Rol güncellenirken hata oluştu.",
  "users.statusChanged": "Durum güncellendi.",
  "users.statusError": "Durum güncellenirken hata oluştu.",

  // SEO
  "seo.header.title": "SEO Ayarları",
  "seo.header.subtitle": "Arama Motoru Optimizasyonu & Google News Yapılandırması",
  "seo.save": "Kaydet",
  "seo.saved": "Kaydedildi",
  "seo.score.title": "SEO Sağlığı",
  "seo.score.subtitle": "puan yerine getirildi",
  "seo.score.label": "SEO Puanı",
  "seo.tab.global": "Genel SEO",
  "seo.tab.sitemap": "Sitemap",
  "seo.tab.schema": "Schema Markup",
  "seo.tab.robots": "robots.txt",
  "seo.tab.checklist": "SEO Kontrol Listesi",
  "seo.global.preview": "Google Arama Sonucu Önizlemesi",
  "seo.global.previewUrl": "Önizleme",
  "seo.sitemap.title": "XML Sitemap",
  "seo.sitemap.index": "Sitemap Dizini",
  "seo.sitemap.news": "Google News Sitemap",
  "seo.sitemap.active": "Aktif",
  "seo.sitemap.urls": "URL",
  "seo.sitemap.infoTitle": "Google News Sitemap",
  "seo.sitemap.infoDesc": "Google News Sitemap yalnızca son 48 saatin makalelerini içerir. Yeni makaleler yayınlandığında otomatik güncellenir. Publisher adınızın Google News'te kayıtlı olanla tam olarak eşleştiğinden emin olun.",
  "seo.schema.title": "Schema Markup",
  "seo.schema.active": "Aktif",
  "seo.schema.inactive": "Pasif",
  "seo.schema.previewOrg": "Organization Schema (Önizleme)",
  "seo.schema.previewNews": "NewsArticle Schema (Örnek)",
  "seo.robots.title": "robots.txt",
  "seo.robots.warningTitle": "Önemli Uyarı",
  "seo.robots.warningDesc": "Admin bölümünün (/admin/) her zaman engellendiğinden emin olun. robots.txt değişiklikleri sitenizin indekslenmesini önemli ölçüde etkileyebilir.",
  "seo.checklist.category": "Kategori",
  "seo.checklist.done": "Tamamlandı",
  "seo.checklist.pending": "Bekliyor",

  // Media
  "media.header.subtitle": "dosya Supabase Storage'da",
  "media.upload.button": "Yükle",
  "media.dropzone.uploading": "Yükleniyor",
  "media.dropzone.title": "Dosyaları buraya sürükleyin veya yüklemek için tıklayın",
  "media.dropzone.hint": "PNG, JPG, GIF, WebP, MP4 (max. 20 MB)",
  "media.filter.placeholder": "Medya ara...",
  "media.filter.allTypes": "Tüm Türler",
  "media.filter.images": "Görseller",
  "media.filter.videos": "Videolar",
  "media.error.title": "Yükleme Hatası",
  "media.grid.empty": "Medya bulunamadı.",
  "media.grid.emptyHint": "Görselleri yüklemek için buraya sürükleyin.",
  "media.grid.copy": "URL Kopyala",
  "media.grid.delete": "Sil",

  // Pages
  "pages.header.subtitle": "sayfa toplam",
  "pages.newPage": "Yeni Sayfa",
  "pages.search.placeholder": "Sayfa ara...",
  "pages.table.col.page": "Sayfa",
  "pages.table.col.slug": "Slug",
  "pages.table.col.metaTitle": "Meta Başlık",
  "pages.table.col.status": "Durum",
  "pages.table.col.sections": "Bölümler",
  "pages.table.col.edited": "Düzenlendi",
  "pages.table.col.actions": "İşlemler",
  "pages.status.published": "Yayınlandı",
  "pages.status.draft": "Taslak",
  "pages.editor.editTitle": "Sayfa Düzenle",
  "pages.editor.newTitle": "Yeni Sayfa",
  "pages.editor.titleLabel": "Başlık",
  "pages.editor.slugLabel": "Slug",
  "pages.editor.metaTitle": "Meta Başlık",
  "pages.editor.metaDesc": "Meta Açıklama",
  "pages.editor.published": "Yayınlandı",
  "pages.editor.draft": "Taslak",
  "pages.editor.intro": "Giriş Metni",
  "pages.editor.sections": "Bölümler",
  "pages.editor.sectionCount": "bölüm",
  "pages.editor.cancel": "İptal",
  "pages.editor.save": "Kaydet",
  "pages.editor.saving": "Kaydediliyor...",
  "pages.preview.title": "Canlı Önizleme",
  "pages.preview.subtitle": "Değişiklikler anında görünür",
  "pages.delete.title": "Sayfa Sil?",
  "pages.delete.description": "Bu işlem geri alınamaz. Sayfa kalıcı olarak kaldırılacak.",
  "pages.delete.cancel": "İptal",
  "pages.delete.confirm": "Sil",

  // Breaking
  "breaking.header.subtitle": "aktif ticker haberi",
  "breaking.search.placeholder": "Makale ara...",
  "breaking.filter.onlyBreaking": "Sadece Son Dakika",
  "breaking.table.active": "Aktif Son Dakika",
  "breaking.table.all": "Tüm Makaleler",
  "breaking.table.empty": "Makale bulunamadı.",
  "breaking.table.noBreaking": "Aktif son dakika haberi yok.",
  "breaking.status.live": "Canlı",
  "breaking.status.draft": "Taslak",
  "breaking.toggle.enable": "Son Dakika Etkinleştir",
  "breaking.toggle.disable": "Son Dakika Devre Dışı Bırak",
  "breaking.error.load": "Yükleme hatası",
  "breaking.error.update": "Güncelleme hatası",

  // Homepage Admin
  "homepageAdmin.header.title": "Ana Sayfa",
  "homepageAdmin.header.subtitle": "Bölümleri sıralayın ve etkinleştirin",
  "homepageAdmin.save": "Kaydet",
  "homepageAdmin.saving": "Kaydediliyor...",
  "homepageAdmin.saved": "Kaydedildi!",
  "homepageAdmin.sections.title": "Bölümler",
  "homepageAdmin.sections.hint": "Sıralamak için okları kullanın, ardından Kaydet'e tıklayın",
  "homepageAdmin.slider.title": "Hero Slider Makaleleri",
  "homepageAdmin.slider.hint": '"Ana Sayfa Slider" işareti etkin olan makaleler burada görünür. İşareti Makale Editöründen ayarlayın.',
  "homepageAdmin.slider.empty": "Slider makalesi bulunamadı.",
  "homepageAdmin.slider.emptyHint": 'Yayınlanmış bir makalede "Ana Sayfa Slider" işaretini etkinleştirin.',

  // Ads
  "ads.header.subtitle": "Google AdSense & reklam yerleşimlerini yönetin",
  "ads.newPlacement": "Yeni Yerleşim",
  "ads.stats.total": "Toplam",
  "ads.stats.active": "Aktif",
  "ads.stats.adsense": "AdSense",
  "ads.stats.impressions": "Görüntülenme",
  "ads.stats.clicks": "Tıklama",
  "ads.stats.ctr": "CTR",
  "ads.adsense.title": "Google AdSense – Publisher ID",
  "ads.adsense.subtitle": "Tüm AdSense yerleşimleri için global Publisher ID",
  "ads.adsense.edit": "Düzenle",
  "ads.adsense.save": "Kaydet",
  "ads.filter.search": "Yerleşim ara...",
  "ads.filter.allTypes": "Tüm Türler",
  "ads.filter.allDevices": "Tüm Cihazlar",
  "ads.filter.allPages": "Tüm Sayfalar",
  "ads.filter.allStatus": "Tüm Durumlar",
  "ads.table.col.name": "Ad",
  "ads.table.col.position": "Pozisyon",
  "ads.table.col.type": "Tür",
  "ads.table.col.device": "Cihaz",
  "ads.table.col.page": "Sayfa",
  "ads.table.col.size": "Boyut",
  "ads.table.col.impressions": "Görüntülenme",
  "ads.table.col.ctr": "CTR",
  "ads.table.col.status": "Durum",
  "ads.table.col.actions": "İşlemler",
  "ads.table.empty": "Yerleşim bulunamadı.",
  "ads.placementMap.title": "Yerleşim Haritası",
  "ads.placementMap.desktop": "Masaüstü",
  "ads.placementMap.mobile": "Mobil",
  "ads.modal.edit": "Reklam Yerleşimi Düzenle",
  "ads.modal.new": "Yeni Reklam Yerleşimi",
  "ads.modal.cancel": "İptal",
  "ads.modal.save": "Kaydet",
  "ads.delete.title": "Yerleşim Sil?",
  "ads.delete.description": "kalıcı olarak silinecek. Bu işlem geri alınamaz.",
  "ads.delete.cancel": "İptal",
  "ads.delete.confirm": "Sil",

  // Authors (mixed language fixes)
  "authors.header.subtitle": "Tüm yazar türlerini tek yerden yönetin",
  "authors.newAuthor": "Yeni Yazar",
  "authors.search.placeholder": "Yazar ara...",
  "authors.type.all": "Tümü",
  "authors.type.redaktion": "Redaktion",
  "authors.type.autor": "Yazarlar",
  "authors.type.kolumnist": "Köşe Yazarları",
  "authors.type.gastautor": "Misafir Yazarlar",
  "authors.type.editor": "Editörler",
  "authors.filter.allStatus": "Tümü Durum",
  "authors.filter.status.active": "Aktif",
  "authors.filter.status.inactive": "Pasif",
  "authors.card.latestArticle": "Son Makale",
  "authors.card.articles": "Makale",
  "authors.card.view": "Görüntüle",
  "authors.card.edit": "Düzenle",
  "authors.card.delete": "Sil",
  "authors.empty.title": "Henüz yazar yok.",
  "authors.empty.noDb": "Veritabanında hiç yazar bulunmuyor.",
  "authors.empty.noFilter": "Filtrelere uygun yazar bulunamadı.",
  "authors.modal.edit": "Yazar Düzenle",
  "authors.modal.new": "Yeni Yazar",
  "authors.modal.general": "Genel",
  "authors.modal.bio": "Biyografi",
  "authors.modal.social": "Sosyal Medya",
  "authors.modal.avatar": "Profil Fotoğrafı",
  "authors.modal.upload": "Fotoğraf Yükle",
  "authors.modal.uploading": "Yükleniyor...",
  "authors.modal.uploadHint": "JPG, PNG, WEBP. Max 5 MB.",
  "authors.modal.name": "Ad",
  "authors.modal.slug": "Slug",
  "authors.modal.role": "Rol",
  "authors.modal.rolePlaceholder": "Editör",
  "authors.modal.email": "E-Posta",
  "authors.modal.type": "Tür",
  "authors.modal.shortBio": "Kısa Biyografi",
  "authors.modal.longBio": "Uzun Biyografi",
  "authors.modal.charCount": "karakter",
  "authors.modal.addSocial": "Bağlantı Ekle",
  "authors.modal.noSocial": "Henüz sosyal medya bağlantısı eklenmedi.",
  "authors.modal.cancel": "İptal",
  "authors.modal.save": "Kaydet",
  "authors.modal.create": "Oluştur",
  "authors.delete.title": "Yazar Sil",
  "authors.delete.description": "adlı yazarı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
  "authors.delete.articlesWarning": "Bu yazarın makalesi var. Bunlar yeniden atanmalıdır.",
  "authors.delete.cancel": "İptal",
  "authors.delete.confirm": "Sil",

  // Footer
  "footer.developedBy": "Geliştiren",
  "footer.allRightsReserved": "Tüm hakları saklıdır.",
  "footer.adminPanel": "Yönetim Paneli",
};

export default tr;
